export enum MetricUnit {
  MONEY = 'MONEY',
  COUNT = 'COUNT',
  PERCENT = 'PERCENT',
}
